var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTuroLogoV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.8405V37.1963H38.7784L0 61.7301V69.908H27.6989L0 92.3313V98.9264H32.9748L0 126.89V129H15.0365C32.0955 115.018 72.7029 93.5448 98.6607 119.503L122.403 91.5399L75.7102 39.3068C93.8244 38.5153 129.631 29.546 127.942 0C124.249 6.94683 108.105 20.8405 73.0722 20.8405H0ZM78.612 64.8957C76.5895 60.6749 69.2208 53.6049 58.0357 58.0368C59.7944 63.7526 66.3717 73.1264 78.612 64.8957Z",
    fill: "#EEBF4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTuroLogoV2);
export default __webpack_public_path__ + "static/media/turo-logo-v2.da28763d13462a88bcaa8bf928b9c8e3.svg";
export { ForwardRef as ReactComponent };